(function (global) {
  'use strict';

  let lightboxCurrentIndex = -1;
  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.GalleryOnPage = global.NewHomeSource.GalleryOnPage || {};
  global.NewHomeSource.GalleryOnPage.CommunityTracking = global.NewHomeSource.GalleryOnPage.CommunityTracking || {};

  class SegmentEvents {
    /**
     * Handles carousel navigation events and dispatches a Segment event.
     */
    static carouselNavigationSegmentEvent() {
      const eventSegment = {
        event: 'Community Image Displayed',
        media_type: 'Community',
        type: 'Listings',
        eventType: 'segmentEvent',
      };

      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventSegment }
      }));
    }

    /**
     * Handles lightbox element change events and dispatches a Segment event.
     *
     * @param {Object} detail - The detail object from the event.
     */
    static lightboxElementChangeSegmentEvent(detail) {
      if (lightboxCurrentIndex !== detail.index) {
        lightboxCurrentIndex = detail.index;
        // Only dispatch event for images (Community Video Played event is tracked via video interaction event)
        if (!detail.isVideo) {
          const eventSegment = {
            event: 'Community Image Displayed',
            media_type: detail.type,
            image_sequence: detail.index + 1,
            image_type: detail.type,
            image_url: detail.url,
            eventType: 'segmentEvent',
          };

          document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
            detail: { data: eventSegment }
          }));
        }
      }
    }

    /**
     * Resets the current index of the lightbox.
     */
    static resetLightboxCurrentIndex() {
      lightboxCurrentIndex = -1;
    }

    /**
     * Handles media click events and dispatches a Segment event.
     */
    static mediaClickSegmentEvent() {
      const eventSegment = {
        event: 'Gallery Viewer Opened',
        media_type: 'Community',
        type: 'Listings',
        eventType: 'segmentEvent',
      };

      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventSegment }
      }));
    }

    /**
     * Handles video interaction events and dispatches a Segment event.
     *
     * @param {Object} detail - The detail object from the event.
     */
    static videoInteractionSegmentEvent(detail) {
      if (detail.interaction === 'video_play') {
        const eventSegment = {
          event: 'Community Video Played',
          media_type: 'Video',
          image_sequence: lightboxCurrentIndex + 1,
          eventType: 'segmentEvent',
        };

        const currentElement = document.querySelector(`[data-column="${lightboxCurrentIndex}"]`);
        if (currentElement) {
          eventSegment.image_type = currentElement.dataset.type;
          eventSegment.image_url = currentElement.dataset.url;
        }

        document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
          detail: { data: eventSegment }
        }));
      }
    }
  }

  global.NewHomeSource.GalleryOnPage.CommunityTracking.SegmentEvents = SegmentEvents;
}(window));
